/** W77 (D-292, D-304): das Blatt zur Nutzungsstatistik fuer Bestandskonten kommt hoechstens einmal je Sitzung. Wie bei
 *  der neuen Fassung (fassung.ts) nur im Speicher: neu laden oder neu anmelden zeigt es wieder, solange der Server den
 *  Hinweis offen haelt (nichts auf dem Geraet ablegen, § 25 TDDDG). */
let gezeigt = false;

export function hinweisGezeigt(): boolean {
  return gezeigt;
}

export function hinweisMerken(): void {
  gezeigt = true;
}

/** Bei einer neuen Anmeldung darf das Blatt wieder kommen. */
export function hinweisZuruecksetzen(): void {
  gezeigt = false;
}

/** W81 B5: ob das Blatt gerade offen ist; das Blatt zur neuen Fassung der Einwilligung wartet, bis es zu ist (nie zwei
 *  Blaetter von selbst uebereinander). */
let offen = false;
const hoerer = new Set<() => void>();

export function hinweisOffen(): boolean {
  return offen;
}

export function hinweisOffenMelden(jetzt: boolean): void {
  if (offen === jetzt) return;
  offen = jetzt;
  for (const h of hoerer) h();
}

export function hinweisBeobachten(h: () => void): () => void {
  hoerer.add(h);
  return () => {
    hoerer.delete(h);
  };
}
